import { css } from "@emotion/react";

import { clearButtonDecoration } from "~/client/styles/emotion/mixins/clearButtonDecoration";
import { fontSize } from "~/client/styles/emotion/mixins/fontSize";
import tokens from "~/packages/design-tokens/dist/tokens";

export const buttonCss = css({
  ...clearButtonDecoration(),
  ...fontSize(12),
  color: tokens.color.text.brand.default.value,
  "&:hover": {
    textDecoration: "underline",
  },
});
